export default {
  toasts: {
    table_selected:
      "Super, sieht so aus, als wäre dein Tisch Nummer: {{number}}",
  },
};
